export const styles = {
    tags: {
        statusTag: {
            display: 'flex',
            justifyContent: 'center',
            fontWeight: 'bold',
            width: '120px',
        },
        default: {
            backgroundColor: '#E8EBED',
            color: '#6E747C',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
        orange: {
            backgroundColor: '#FFF1AD',
            color: '#EB9400',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
        red: {
            backgroundColor: '#FFD9D6',
            color: '#E15147',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
        gray: {
            backgroundColor: '#E8EBED',
            color: '#6E747C',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
        green: {
            backgroundColor: '#DAF4CD',
            color: '#1FAD1F',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
        dentium_green: {
            backgroundColor: '#E9F3BA',
            color: '#68AD00',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
        blue: {
            backgroundColor: '#E1F0FF',
            color: '#278AEC',
            borderRadius: '8px',
            border: '1px solid rgba(0, 0, 0, 0.05)'
        },
    },
    manager: {
        name: {
            textOverflow: 'ellipsis',
            fontWeight: '500',
            lineHeight: '13px',
            color: 'Gray-60', // Replace with hex or rgba color code if possible
        },
        desc: {
            fontSize: '12px',
            color: '#ACB2B9',
        }
    },
    extraBtnWrap: {
        display: 'flex',
        gap: '16px',
        padding: '0 10px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btn: {
        'btn-hover': {
            transition: 'ease-in-out 0.2s',
            '&:hover': {
                transition: 'ease-in-out 0.2s',
                filter: 'brightness(1.05) !important'
            },
            '&:active': {
                transition: 'ease-in-out 0.2s',
                filter: 'brightness(0.95) !important'
            }
        },
        'round-btn': {
            border: 'none',
            width: '28px !important',
            height: '28px !important',
            padding: 0,
            textAlign: 'center !important',
            borderRadius: '100%',
            'i': {
                fontSize: '16px',
                borderRadius: '100%',
                width: '28px',
                height: '28px',
                color: 'Gray-60', // SASS 변수를 사용한 부분이므로 적절한 JS 변수 또는 값을 할당해야 합니다.
                marginRight: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'Gray-20', // SASS 변수를 사용한 부분이므로 적절한 JS 변수 또는 값을 할당해야 합니다.
                '&:hover': {
                    boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.05) inset',
                }
            }
        }
    }
}